import React, { useState } from 'react';
import { storageRef } from '../../../utils/firebase';
import {Radio, Spin, Row, Col, Form, Input, InputNumber, Button} from 'antd';
import './ComponentsStylesheet.css';
import GooglePicker from '../../../../node_modules/react-google-picker';
import { GOOGLE_FILEPICKER } from "../../../config/common";

const { Item: FormItem } = Form;
const ALIGNMENT_OPTIONS = {
    HORIZONTAL : [ "Left", "Center", "Right"]
}

/*-----------------------------------*/
/*             Component             */
/*-----------------------------------*/

const Component = ({ src: propSrc, alt: propAlt, caption = 'Image info caption', width = 0, height = 0 , horizontalAlignment = "Center"}) => {
    const [src, setSrc] = useState();
    const [alt, setAlt] = useState();

    const getWidth = () => {
        if (width !== '' && width > 0) {
            return width + 'px';
        } else if (height !== '' && height > 0) {
            return 'auto';
        } else {
            return '100%';
        }
    };

    const getHeight = () => {
        if (height !== '' && height > 0) {
            return height + 'px';
        } else if (width !== '' && width > 0) {
            return 'auto';
        } else {
            return '100%';
        }
    };

    if ((src !== propSrc && propSrc) && (alt !== propAlt && propAlt)) {
        setSrc(propSrc);
        setAlt(propAlt);
        return;
    } else if (!src && !propSrc) {
        storageRef
            .ref('static/images/No-Image.png')
            .getDownloadURL()
            .then(url => {
                setAlt(propAlt);
                setSrc(url);
            });
        return (
            <div className="spinner">
                <Spin />
            </div>
        );
    }
    return (
        <div style={{ width: getWidth(), height: getHeight() }} className={"image-block " + horizontalAlignment.toLowerCase()}>
            <div className="image-wrapper">
                <img src={src} alt={alt} style={{ width: getWidth(), height: getHeight() }} />
                <span>{caption}</span>
            </div>
        </div>
    );
};

/*-----------------------------------*/
/*               Form                */
/*-----------------------------------*/

const EditForm = props => {
    const { getFieldDecorator, setFieldsValue } = props.form;
    const [src, setSrc] = useState(props.src);
    const [alt, setAlt] = useState(props.alt);
    const [width, setWidth] = useState(props.width);
    const [height, setHeight] = useState(props.height);
    const [caption, setCaption] = useState(props.caption);    
    const [horizontalAlignment, setHorizontalAlignment] = useState(props.horizontalAlignment);

    props.form.mapValuesToProps = values => {
        values.alt = alt;
        return values;
    };

    const handleImageChanged = e => {
        if(e.docs){
            const imgURL = GOOGLE_FILEPICKER.IMAGE_PICKER.URL_PREFIX + e.docs[0].id + GOOGLE_FILEPICKER.IMAGE_PICKER.URL_SUFFIX ;
            
            setFieldsValue({src : imgURL});

            setSrc(imgURL);
            setAlt(e.docs[0].name);
        }
    };
    const handleCaptionChanged = e => {
        setCaption(e.target.value);
    };
    const handleWidthChanged = value => {
        setWidth(value);
    };
    const handleHeightChanged = value => {
        setHeight(value);
    };
    const handleHorizontalAlignmentChanged = event => {
        setHorizontalAlignment(event.target.value);
    };

    return (
        <React.Fragment>
            <Row type="flex" justify="space-around" style={{ marginBottom: '1rem' }}>
                <Col span={24} style={{overflow : 'auto', maxHeight:"50vh", maxWidth:"70vw"}}>
                    <Component src={src} alt={alt} caption={caption} width={width} height={height} horizontalAlignment={horizontalAlignment} />
                </Col>
            </Row>
            <Row style={{margin:"0.25rem"}}>
                <Col span={12} style={{padding:"0.5rem 0.25rem"}}>
                    <FormItem required label="Image url">
                        {getFieldDecorator('src', { rules: [{ required: true }], initialValue: src })(
                            <GooglePicker clientId={GOOGLE_FILEPICKER.GENERAL.CLIENT_ID}
                                          developerKey={GOOGLE_FILEPICKER.GENERAL.DEVELOPER_KEY}
                                          scope={GOOGLE_FILEPICKER.GENERAL.SCOPE}
                                          onAuthFailed={data => console.log('on auth failed:', data)}
                                          multiselect={false}
                                          navHidden={true}
                                          authImmediate={false}
                                          viewId={'FOLDERS'}
                                          createPicker={ (google, oauthToken) => {
                                              const googleViewId = google.picker.ViewId.DOCS;
                                              const docsView = new google.picker.DocsView(googleViewId)
                                                  .setIncludeFolders(false)
                                                  .setMimeTypes("image/png,image/jpeg,image/jpg,application/vnd.google-apps.folder")
                                                  .setParent(GOOGLE_FILEPICKER.IMAGE_PICKER.FODLER_ID)
                                                  .setEnableDrives(true)
                                                  .setSelectFolderEnabled(false);

                                              const picker = new window.google.picker.PickerBuilder()
                                                  .addView(docsView)
                                                  .setOAuthToken(oauthToken)
                                                  .setDeveloperKey(GOOGLE_FILEPICKER.GENERAL.DEVELOPER_KEY)
                                                  .enableFeature(google.picker.Feature.SUPPORT_DRIVES)
                                                  .enableFeature(google.picker.Feature.NAV_HIDDEN)
                                                  .setCallback((e)=>{
                                                      if(e.action === "picked"){
                                                          handleImageChanged(e);
                                                      }
                                                  });

                                              picker.build().setVisible(true);
                                          }}
                            >
                                <Button type="dashed" icon="setting" style={{ width: '100%' }}>
                                    Select from Drive
                                </Button>
                                <div className="google"/>
                            </GooglePicker>
                        )}
                    </FormItem>
                </Col>
                <Col span={12} style={{padding:"0.5rem 0.25rem"}}>
                    <FormItem hasFeedback label="Caption">
                        {getFieldDecorator('caption', { initialValue: caption })(
                            <Input name="caption" placeholder="please enter a caption text." onChange={handleCaptionChanged} />
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row style={{margin:"0.25rem"}}>
                <Col span={6} style={{padding:"0.5rem 0.25rem"}}>
                    <FormItem hasFeedback label="Width">
                        {getFieldDecorator('width', { initialValue: width })(<InputNumber name="width" placeholder="width in px" onChange={handleWidthChanged} style={{ width: '100%' }} />)}
                    </FormItem>
                </Col>
                <Col span={6} style={{padding:"0.5rem 0.25rem"}}>
                    <FormItem hasFeedback label="Height">
                        {getFieldDecorator('height', { initialValue: height })(<InputNumber name="height" placeholder="height in px" onChange={handleHeightChanged} style={{ width: '100%' }} />)}
                    </FormItem>
                </Col>
                <Col span={12} style={{padding:"0.5rem 0.25rem"}}>
                    <FormItem label="Horizontal alignment">
                        {
                            getFieldDecorator('horizontalAlignment', { initialValue: horizontalAlignment })(
                                <Radio.Group style={{ width: '100%' }} onChange={handleHorizontalAlignmentChanged}>
                                    {
                                        ALIGNMENT_OPTIONS.HORIZONTAL.map((option, index) => {
                                            return <Radio.Button key={index} value={option}>{option}</Radio.Button>
                                        })
                                    }
                                </Radio.Group>
                            )
                        }
                    </FormItem>
                </Col>
            </Row>
        </React.Fragment>
    );
};
EditForm.defaultProps = {
    caption: '',
    alt: '',
    height: '',
    width: '',
    src: '',
    horizontalAlignment : 'Center',
};

export { Component, EditForm };
